import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import LOGO from '../../assets/LOGO.png';

function NavBar() {
  return (
    <nav className="nav" style={{ background: 'rgba(17,17,17,0.98)', borderBottom: '1px solid #222', position: 'sticky', top: 0, zIndex: 100 }}>
      <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', py: 2 }}>
        <Link to="/">
          <img src={LOGO} alt="Happenings Logo" style={{ height: 38, marginRight: 24 }} />
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Link to="/terms" style={{ color: '#f3f3f3', textDecoration: 'none', fontWeight: 500, fontSize: 16 }}>Terms</Link>
          <Link to="/privacy" style={{ color: '#f3f3f3', textDecoration: 'none', fontWeight: 500, fontSize: 16 }}>Privacy</Link>
        </Box>
      </Container>
    </nav>
  );
}

const SectionDivider = () => (
  <Divider sx={{ my: 5, borderColor: '#333', borderBottomWidth: 2, opacity: 0.5 }} />
);

const TermsOfServicePage = () => {
  return (
    <Box sx={{ minHeight: '100vh', width: '100vw', bgcolor: '#111', color: '#f3f3f3', pb: 10 }}>
      <NavBar />
      <Container maxWidth="md" sx={{ pt: 10, pb: 8 }}>
        <Typography variant="h2" sx={{ fontSize: { xs: '2.5rem', md: '4rem' }, fontWeight: 700, textAlign: 'center', mb: 2, letterSpacing: '-0.04em', lineHeight: 1.1 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#ccc', textAlign: 'center', mb: 6, fontSize: { xs: '1rem', md: '1.25rem' } }}>
          Effective Date: May 29, 2025
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' }, color: '#e0e0e0', mb: 3, lineHeight: 1.7 }}>
          These Terms and Conditions (“Terms”) govern your access to and use of the Happenings Holdings Inc. platform (“Happenings”, “we”, “our”, or “us”), including any features, content, or services offered through our website or mobile platform. By creating an account or using our services, you agree to be bound by these Terms.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          1. Access and Use of the Service
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We grant you a limited, non-exclusive, non-transferable license to access and use the Happenings platform for your internal business or event planning purposes. You must not use the platform for unlawful purposes or violate any laws while using our service.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          2. Account Registration and Security
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          To access most features, you must register an account and provide accurate information. You are responsible for maintaining the confidentiality of your account credentials and all activity under your account. Notify us immediately of any unauthorized access or breach.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          3. Fees and Payments
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Access to certain features may require payment. Fees will be clearly disclosed prior to purchase. All payments are processed securely via third-party payment providers. Happenings is not liable for issues arising from third-party payment platforms.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          4. Marketplace Transactions
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Happenings facilitates transactions between event hosts and third-party providers (venues, vendors, sponsors). We do not guarantee the performance, quality, or legality of any services booked through the platform. Users are responsible for conducting their own due diligence.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          5. User Responsibilities
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          You agree not to:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 24, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Use the platform to distribute spam, malware, or harmful content</li>
          <li>Violate intellectual property rights of others</li>
          <li>Interfere with the security or performance of the platform</li>
          <li>Attempt to reverse engineer or copy the platform's source code</li>
        </ul>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          6. Intellectual Property
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          All content and software associated with Happenings is the property of Happenings Inc. or its licensors. Except for the limited rights granted, no part of the service may be copied, modified, or distributed without prior written consent.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          7. Termination
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We may suspend or terminate your access at any time if you violate these Terms, without liability. You may terminate your account at any time by contacting support. Upon termination, your license to use the service ends immediately.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          8. Disclaimers and Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          The platform is provided "as is" without warranties of any kind. We do not guarantee uptime, performance, or results. In no event shall Happenings be liable for indirect, incidental, or consequential damages arising from your use of the service.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          9. Changes to Terms
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We reserve the right to modify these Terms at any time. Updates will be posted on our website, and continued use of the platform signifies acceptance of the revised Terms.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          10. Governing Law
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          These Terms are governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of laws principles.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          11. Refunds and Cancellations
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          All transactions on the Happenings platform are between the Host and the third-party provider. Happenings is not responsible for refunds or cancellations. Users are encouraged to review the terms of individual vendors prior to booking.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          12. Service Availability
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We strive to maintain reliable service but do not guarantee uptime or uninterrupted access. Temporary interruptions may occur for maintenance, upgrades, or unforeseen issues.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          13. Privacy
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Your use of the Service is subject to our <a href="/privacy" style={{ color: '#8b5cf6', textDecoration: 'underline' }}>Privacy Policy</a>, which outlines how we collect, use, and share your personal information.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          14. Indemnification
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          You agree to indemnify, defend, and hold harmless Happenings, its affiliates, and employees from any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of your use of the platform or violation of these Terms.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          15. Dispute Resolution and Arbitration
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Any disputes arising out of or related to these Terms or your use of the Service shall be resolved through binding arbitration conducted in New York County, New York, under the rules of the American Arbitration Association. You waive the right to participate in class actions or jury trials.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          16. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          For questions about these Terms, contact us at:<br />
          <b>Email:</b> <a href="mailto:team@happenings.dev" style={{ color: '#8b5cf6', textDecoration: 'underline' }}>team@happenings.dev</a>
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage; 